import { render } from "./body_main_banner7.vue?vue&type=template&id=5bc66c4e&scoped=true"
import script from "./body_main_banner7.vue?vue&type=script&lang=js"
export * from "./body_main_banner7.vue?vue&type=script&lang=js"

import "./body_main_banner7.vue?vue&type=style&index=0&id=5bc66c4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc66c4e"]])

export default __exports__